import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Event from './Event';

const useStyles = makeStyles(() => ({
  container: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    margin: '20px 0',
    paddingBottom: 20,
    width: '100%'
  },
}))

function GameEvents({ events, ...props }) {
  const [page, setPage] = useState(0);
  const classes = useStyles();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const ROWS_PER_PAGE = isMobile ? 5 : 25;

  function handlePageChange(event, newPage){
    setPage(newPage);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Pagination
          component="div"
          count={events.length}
          rowsPerPage={ROWS_PER_PAGE}
          page={page}
          backIconButtonProps={{ 'aria-label': 'Previous Page' }}
          nextIconButtonProps={{ 'aria-label': 'Next Page' }}
          rowsPerPageOptions={[]}
          onChangePage={handlePageChange}
        />
      </Grid>
      { events
        .slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE)
        .map(event => (
          <div
            key={event.id}
            className={classes.container}
          >
            <Event event={event} {...props} />
          </div>
        ))
      }
      <Grid item xs={12}>
        <Pagination
          component="div"
          count={events.length}
          rowsPerPage={ROWS_PER_PAGE}
          page={page}
          backIconButtonProps={{ 'aria-label': 'Previous Page' }}
          nextIconButtonProps={{ 'aria-label': 'Next Page' }}
          rowsPerPageOptions={[]}
          onChangePage={handlePageChange}
        />
      </Grid>
    </Grid>
  )
}

export default GameEvents;
